import { FC, useState } from "react";
import SelectableTable from "./drawls/tableDrawls";
import { InfoCard } from "./drawls/infoCard";
import ModalUI from "../../../components/modalUI/ModalUI";
import { ModalWithdrawl } from "./drawls/modalWithdrawal";
import useCreateWithDrawls from "../../../service/userCreateWithDrawls/createWithDrawls";
import SnackBar from "../../../components/notification/snackbar/snackbar";
import useCreateWithdrawals from "../../../service/userCreateWithDrawls/createWithDrawls";
import { GridDrawl } from "./drawls/tableDrawls/tableDrawls/GridDrawl";
import { useNavigate } from "react-router-dom";
import { useProfileBalance } from "../../../context/ProfileContext/ProfileBalanceContext/ProfileBalanceContext";
import { CardInfo } from "../../../components/common/cardInfo/CardInfo";
import AutomaticWithDrawals from "./AutomaticWithdrawals";
import { Box } from "@mui/material";
import useFetchAccountsBank from "../../../service/userBankAccount/getUserAccountBank";


export const Withdrawals = () => {
  const storedToken = sessionStorage.getItem("userData");
  const navigate = useNavigate();
  const { refreshBalance } = useProfileBalance();
  const { accountsBank, loading: loadiadinAccount} = useFetchAccountsBank(storedToken || "");

  const [rowData, setRowData] = useState<any>();
  const [getAccout, setGetAccount] = useState<any>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openMessage, setOpenMessage] = useState<boolean>(false);

  const [objectWithdrawl, setObjectWithdrawl] = useState<any>(null);
  const [message, setMessage] = useState<string>("");
  const [severity, setSeverity] = useState<
    "success" | "info" | "warning" | "error"
  >("info");

  const totalCost = rowData?.reduce((acc: any, item: any) => {
    return acc + (item?.amount_with_comision || 0);
  }, 0);

  const createObjectWithdrawl = () => {
    if (!rowData || !getAccout) {
      return null;
    }

    const objectWithdrawal = {
      amount: totalCost,
      transactions: rowData?.map((tx: any) => tx.id),
      profileId: getAccout.profile_id,
      stp_date: {
        name: getAccout.name,
        account_number: getAccout.account_number,
        type_of_account: getAccout.type_of_account,
        code_bank: getAccout.code_bank,
      },
    };

    setObjectWithdrawl(objectWithdrawal);
  };

  const onClickCreateWithDrawl = () => {
    createObjectWithdrawl();
    setOpenModal(true);
  };

  const onClickExitModal = () => {
    setOpenModal(false);
  };

  const { loading, createWithdrawals } = useCreateWithdrawals();

  const onClickFetchWithDrawl = async () => {
    try {
      setMessage("");
      setSeverity("info");
      const result = await createWithdrawals(storedToken, objectWithdrawl);
      if (result?.success === true) {
        setSeverity("success");
        setMessage(
          "Se ha solicitado un retiro: Una vez solicitado el retirno Ver en historial",
        );
        setOpenMessage(true);
        setOpenModal(false);
        navigate("/transferencias/historial");
      } else {
        setSeverity("info");

        setMessage("Error al generar un retiro.");
        setOpenMessage(true);
      }
    } catch (err: any) {
      setMessage("Ocurrió un error inesperado.");
      setOpenMessage(true);
    } finally {
      refreshBalance();
    }
  };

  const formatBankAccount =
    accountsBank?.data &&
    accountsBank?.data.map((item: any) => {
      const object = {
        id: item.name,
        value: item,
        label: item?.name + " - " + item?.account_number,
      };

      return object;
    });

  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "repeat(2, minmax(0, 1fr))" },
          gap: { xs: 2, sm: 3 },
          alignItems: "stretch",
          width: "100%",
          minWidth: 0,
        }}
      >
{/* 
        <InfoCard
          setData={setGetAccount}
          totalAmount={totalCost || 0}
          onChange={onClickCreateWithDrawl}
        /> */}

        <InfoCard
          setData={setGetAccount}
          transformData={formatBankAccount}
          totalAmount={totalCost || 0}
          onChange={onClickCreateWithDrawl}
        />
        <AutomaticWithDrawals
          data={totalCost || 0}
          bankAccount={formatBankAccount}
        />
      </Box>

      <Box sx={{ mt: { xs: 2, sm: 3 }, width: "100%", minWidth: 0 }}>
        <GridDrawl setRow={setRowData} />
      </Box>
        {/* <SelectableTable setData={setRowData} /> */}
        <ModalUI
          children={
            <ModalWithdrawl
              loading={loading}
              data={objectWithdrawl}
              onClickBack={onClickExitModal}
              onClickAccept={onClickFetchWithDrawl}
            />
          }
          setOpen={setOpenModal}
          open={openModal}
        />
        <SnackBar
          severity={severity}
          onClose={() => setOpenMessage(false)}
          message={message}
          open={openMessage}
        />
    </Box>
  );
};
